import { render } from "./PropertyGalery.vue?vue&type=template&id=1b0cb617"
import script from "./PropertyGalery.vue?vue&type=script&lang=js"
export * from "./PropertyGalery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__